module.exports = __webpack_public_path__ + "img/discountStatus3.5d65dd32.svg";